import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgBedsideUsbCharging = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 14,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0v7h1a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H7.5v2h-1v-2H1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V0h10Zm1 8H1v13h12V8Zm-5.276 2.053a.5.5 0 0 1 .256.587l-.033.084L6.31 14H8.5a.5.5 0 0 1 .478.646l-.03.078-2 4a.5.5 0 0 1-.928-.364l.033-.084L7.69 15H5.5a.5.5 0 0 1-.478-.646l.03-.078 2-4a.5.5 0 0 1 .672-.223ZM11 1H3v6h8V1ZM6 3v2H5V3h1Zm3 0v2H8V3h1Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgBedsideUsbCharging;